export class HotelLanguage {
  Code: string;
  Name: String;
}
